import React from 'react';
import { SRLWrapper } from "simple-react-lightbox";

import './Portfolio.scss'
import ProtoImg from "./PortoImg";

export default class Portfolio extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <div className="portfolio-wrapper">
                <div className="portfolio">
                    <span className="porto-title">
                        <strong>
                            Portfolio
                        </strong>
                    </span>
                    <div className="pt-5">
                        <div className="container-fluid">
                            <SRLWrapper>
                                <div className="row">
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=1"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=2"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=3"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=4"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=5"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=6"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=7"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=8"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=9"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=10"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=11"} subTitle={"NAME > Author"} />
                                    <ProtoImg img={"https://picsum.photos/1920/1080?random=14"} subTitle={"NAME > Author"} />
                                </div>
                            </SRLWrapper>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
